export default {
  data() {

  },
  methods:{
    _openAdd(record) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/test.js